import React, { useState } from 'react';
import { DataGrid } from '@/components/DataGrid/DataGrid';
import { EditButton, RecordField, TextField } from '@/shared/ui/Fields/Fields';
import { TestCaseGroupResponseDTO, TestCaseListResponseDTO } from '@/shared/api/gen/data-contracts';
import './TestCaseGroupAccordion.scss';

interface UngroupedGroup {
    id: null;
    title: string;
    description?: null;
    priority?: null;
}

interface Props {
    group: TestCaseGroupResponseDTO | UngroupedGroup;
    groups: TestCaseGroupResponseDTO[];
    testCases: TestCaseListResponseDTO[];
    onArchive: (id: number) => void;
    onMoveToGroup: (caseId: number, groupId: number | null) => void;
}

export function TestCaseGroupAccordion({ group, groups, testCases, onArchive, onMoveToGroup }: Props) {
    const [open, setOpen] = useState(false);

    return (
        <div className="GroupAccordion">
            <div className="GroupAccordion__header" onClick={() => setOpen(p => !p)}>
                <span className={`GroupAccordion__chevron${open ? ' GroupAccordion__chevron--open' : ''}`}>▶</span>
                <span className="text-15 bold GroupAccordion__title">{group.title}</span>
                {group.description && (
                    <span className="text-13 GroupAccordion__description">{group.description}</span>
                )}
                <div className="GroupAccordion__meta">
                    {group.priority != null && (
                        <span className="GroupAccordion__badge">P{group.priority}</span>
                    )}
                    <span className="text-13 secondary">{testCases.length} кейсов</span>
                </div>
            </div>

            {open && (
                <div className="GroupAccordion__body">
                    <DataGrid title="" records={testCases}>
                        <TextField key="id" label="ID" />
                        <RecordField
                            label="Название"
                            render={(record) => (
                                <span
                                    className="text-14"
                                    title={record?.title}
                                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}
                                >
                                    {record?.title}
                                </span>
                            )}
                        />
                        <TextField key="priority" label="Приоритет" />
                        <TextField key="status" label="Статус" />
                        <EditButton key="id" urlPrefix="/test_cases/update/" label="Редактировать" />
                        <RecordField
                            label="Группа"
                            render={(record) => (
                                <select
                                    className="GroupAccordion__groupSelect"
                                    defaultValue={record?.group_ref ?? ''}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        onMoveToGroup(record?.id, val === '' ? null : Number(val));
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <option value="">— Без группы</option>
                                    {groups.map((g) => (
                                        <option key={g.id} value={g.id}>{g.title}</option>
                                    ))}
                                </select>
                            )}
                        />
                        <RecordField
                            label="Архив"
                            render={(record) => (
                                <div className="text-14 cursor-pointer secondary" onClick={() => onArchive(record?.id)}>
                                    В архив
                                </div>
                            )}
                        />
                    </DataGrid>
                </div>
            )}
        </div>
    );
}
